import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';
import { getT } from './translations';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('NL');

  const value = useMemo(() => ({
    lang,
    setLang: (next) => setLang(next),
    t: getT(lang),
  }), [lang]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used inside LanguageProvider');
  return ctx;
};
